import { render } from "./HeroiconsSolidTranslate.vue?vue&type=template&id=b24bdfce"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTranslate.vue"]])

export default __exports__